/* parser generated by jison 0.4.18 */
/*
  Returns a Parser object of the following structure:

  Parser: {
    yy: {}
  }

  Parser.prototype: {
    yy: {},
    trace: function(),
    symbols_: {associative list: name ==> number},
    terminals_: {associative list: number ==> name},
    productions_: [...],
    performAction: function anonymous(yytext, yyleng, yylineno, yy, yystate, $$, _$),
    table: [...],
    defaultActions: {...},
    parseError: function(str, hash),
    parse: function(input),

    lexer: {
        EOF: 1,
        parseError: function(str, hash),
        setInput: function(input),
        input: function(),
        unput: function(str),
        more: function(),
        less: function(n),
        pastInput: function(),
        upcomingInput: function(),
        showPosition: function(),
        test_match: function(regex_match_array, rule_index),
        next: function(),
        lex: function(),
        begin: function(condition),
        popState: function(),
        _currentRules: function(),
        topState: function(),
        pushState: function(condition),

        options: {
            ranges: boolean           (optional: true ==> token location info will include a .range[] member)
            flex: boolean             (optional: true ==> flex-like lexing behaviour where the rules are tested exhaustively to find the longest match)
            backtrack_lexer: boolean  (optional: true ==> lexer regexes are tested in order and for each matching regex the action code is invoked; the lexer terminates the scan when a token is returned by the action code)
        },

        performAction: function(yy, yy_, $avoiding_name_collisions, YY_START),
        rules: [...],
        conditions: {associative list: name ==> set},
    }
  }


  token location info (@$, _$, etc.): {
    first_line: n,
    last_line: n,
    first_column: n,
    last_column: n,
    range: [start_number, end_number]       (where the numbers are indexes into the input string, regular zero-based)
  }


  the parseError function receives a 'hash' object with these members for lexer and parser errors: {
    text:        (matched text)
    token:       (the produced terminal token, if any)
    line:        (yylineno)
  }
  while parser (grammar) errors will also provide these members, i.e. parser errors deliver a superset of attributes: {
    loc:         (yylloc)
    expected:    (string describing the set of expected tokens)
    recoverable: (boolean: TRUE when the parser has a error recovery rule available for this particular error)
  }
*/
var parser = (function(){
var o=function(k,v,o,l){for(o=o||{},l=k.length;l--;o[k[l]]=v);return o},$V0=[1,6],$V1=[1,7],$V2=[1,8],$V3=[1,9],$V4=[1,16],$V5=[1,11],$V6=[1,12],$V7=[1,13],$V8=[1,14],$V9=[1,15],$Va=[1,27],$Vb=[1,33],$Vc=[1,34],$Vd=[1,66],$Ve=[1,67],$Vf=[1,68],$Vg=[1,69],$Vh=[1,70],$Vi=[1,71],$Vj=[1,72],$Vk=[1,35],$Vl=[1,36],$Vm=[1,37],$Vn=[1,38],$Vo=[1,39],$Vp=[1,40],$Vq=[1,41],$Vr=[1,42],$Vs=[1,43],$Vt=[1,44],$Vu=[1,45],$Vv=[1,46],$Vw=[1,47],$Vx=[1,48],$Vy=[1,49],$Vz=[1,50],$VA=[1,51],$VB=[1,52],$VC=[1,53],$VD=[1,54],$VE=[1,56],$VF=[1,57],$VG=[1,58],$VH=[1,59],$VI=[1,60],$VJ=[1,61],$VK=[1,62],$VL=[1,63],$VM=[24,47],$VN=[24,39,41,42,43,44,45,46,47,49,50,51,52,53,54,55,56,57,58,59,60,61,62,63,64,65,66,67,68,69,70,71,72,73,74,75,76],$VO=[15,24,39,41,42,43,44,45,46,47,49,50,51,52,53,54,55,56,57,58,59,60,61,62,63,64,65,66,67,68,69,70,71,72,73,74,75,76],$VP=[1,86],$VQ=[1,87],$VR=[1,88],$VS=[15,24,47],$VT=[7,8,9,10,18,22,25,26,27,28],$VU=[15,24,38,47],$VV=[15,24,38,47,78,79,80],$VW=[15,38],$VX=[39,41,42,43,44,45,46,49,50,51,52,53,54,55,56,57,58,59,60,61,62,63,64,65,66,67,68,69,70,71,72,73,74,75,76];
var parser = {trace: function trace () { },
yy: {},
symbols_: {"error":2,"start":3,"mermaidDoc":4,"direction":5,"directive":6,"direction_tb":7,"direction_bt":8,"direction_rl":9,"direction_lr":10,"graphConfig":11,"openDirective":12,"typeDirective":13,"closeDirective":14,"NEWLINE":15,":":16,"argDirective":17,"open_directive":18,"type_directive":19,"arg_directive":20,"close_directive":21,"C4_CONTEXT":22,"statements":23,"EOF":24,"C4_CONTAINER":25,"C4_COMPONENT":26,"C4_DYNAMIC":27,"C4_DEPLOYMENT":28,"otherStatements":29,"diagramStatements":30,"otherStatement":31,"title":32,"accDescription":33,"boundaryStatement":34,"boundaryStartStatement":35,"boundaryStopStatement":36,"boundaryStart":37,"LBRACE":38,"ENTERPRISE_BOUNDARY":39,"attributes":40,"SYSTEM_BOUNDARY":41,"BOUNDARY":42,"CONTAINER_BOUNDARY":43,"NODE":44,"NODE_L":45,"NODE_R":46,"RBRACE":47,"diagramStatement":48,"PERSON":49,"PERSON_EXT":50,"SYSTEM":51,"SYSTEM_DB":52,"SYSTEM_QUEUE":53,"SYSTEM_EXT":54,"SYSTEM_EXT_DB":55,"SYSTEM_EXT_QUEUE":56,"CONTAINER":57,"CONTAINER_DB":58,"CONTAINER_QUEUE":59,"CONTAINER_EXT":60,"CONTAINER_EXT_DB":61,"CONTAINER_EXT_QUEUE":62,"COMPONENT":63,"COMPONENT_DB":64,"COMPONENT_QUEUE":65,"COMPONENT_EXT":66,"COMPONENT_EXT_DB":67,"COMPONENT_EXT_QUEUE":68,"REL":69,"BIREL":70,"REL_U":71,"REL_D":72,"REL_L":73,"REL_R":74,"REL_B":75,"REL_INDEX":76,"attribute":77,"STR":78,"ATTRIBUTE":79,"ATTRIBUTE_EMPTY":80,"$accept":0,"$end":1},
terminals_: {2:"error",7:"direction_tb",8:"direction_bt",9:"direction_rl",10:"direction_lr",15:"NEWLINE",16:":",18:"open_directive",19:"type_directive",20:"arg_directive",21:"close_directive",22:"C4_CONTEXT",24:"EOF",25:"C4_CONTAINER",26:"C4_COMPONENT",27:"C4_DYNAMIC",28:"C4_DEPLOYMENT",32:"title",33:"accDescription",38:"LBRACE",39:"ENTERPRISE_BOUNDARY",41:"SYSTEM_BOUNDARY",42:"BOUNDARY",43:"CONTAINER_BOUNDARY",44:"NODE",45:"NODE_L",46:"NODE_R",47:"RBRACE",49:"PERSON",50:"PERSON_EXT",51:"SYSTEM",52:"SYSTEM_DB",53:"SYSTEM_QUEUE",54:"SYSTEM_EXT",55:"SYSTEM_EXT_DB",56:"SYSTEM_EXT_QUEUE",57:"CONTAINER",58:"CONTAINER_DB",59:"CONTAINER_QUEUE",60:"CONTAINER_EXT",61:"CONTAINER_EXT_DB",62:"CONTAINER_EXT_QUEUE",63:"COMPONENT",64:"COMPONENT_DB",65:"COMPONENT_QUEUE",66:"COMPONENT_EXT",67:"COMPONENT_EXT_DB",68:"COMPONENT_EXT_QUEUE",69:"REL",70:"BIREL",71:"REL_U",72:"REL_D",73:"REL_L",74:"REL_R",75:"REL_B",76:"REL_INDEX",78:"STR",79:"ATTRIBUTE",80:"ATTRIBUTE_EMPTY"},
productions_: [0,[3,1],[3,1],[3,2],[5,1],[5,1],[5,1],[5,1],[4,1],[6,4],[6,6],[12,1],[13,1],[17,1],[14,1],[11,4],[11,4],[11,4],[11,4],[11,4],[23,1],[23,1],[23,2],[29,1],[29,2],[29,3],[31,1],[31,1],[34,3],[35,3],[35,3],[35,4],[37,2],[37,2],[37,2],[37,2],[37,2],[37,2],[37,2],[36,1],[30,1],[30,2],[30,3],[48,2],[48,2],[48,2],[48,2],[48,2],[48,2],[48,2],[48,2],[48,2],[48,2],[48,2],[48,2],[48,2],[48,2],[48,2],[48,2],[48,2],[48,2],[48,2],[48,2],[48,1],[48,2],[48,2],[48,2],[48,2],[48,2],[48,2],[48,2],[48,2],[40,1],[40,2],[77,1],[77,1],[77,1]],
performAction: function anonymous(yytext, yyleng, yylineno, yy, yystate /* action[1] */, $$ /* vstack */, _$ /* lstack */) {
/* this == yyval */

var $0 = $$.length - 1;
switch (yystate) {
case 4:
 yy.setDirection('TB');
break;
case 5:
 yy.setDirection('BT');
break;
case 6:
 yy.setDirection('RL');
break;
case 7:
 yy.setDirection('LR');
break;
case 11:
 console.log("open_directive: ", $$[$0]); yy.parseDirective('%%{', 'open_directive'); 
break;
case 12:
  
break;
case 13:
 $$[$0] = $$[$0].trim().replace(/'/g, '"'); console.log("arg_directive: ", $$[$0]); yy.parseDirective($$[$0], 'arg_directive'); 
break;
case 14:
 console.log("close_directive: ", $$[$0]); yy.parseDirective('}%%', 'close_directive', 'c4Context');  
break;
case 15: case 16: case 17: case 18: case 19:
yy.setC4Type($$[$0-3])
break;
case 26:
yy.setTitle($$[$0].substring(6));this.$=$$[$0].substring(6);
break;
case 27:
yy.setAccDescription($$[$0].substring(15));this.$=$$[$0].substring(15);
break;
case 32: case 33:
console.log($$[$0-1],JSON.stringify($$[$0])); $$[$0].splice(2, 0, 'ENTERPRISE'); yy.addPersonOrSystemBoundary(...$$[$0]); this.$=$$[$0];
break;
case 34:
console.log($$[$0-1],JSON.stringify($$[$0])); yy.addPersonOrSystemBoundary(...$$[$0]); this.$=$$[$0];
break;
case 35:
console.log($$[$0-1],JSON.stringify($$[$0])); $$[$0].splice(2, 0, 'CONTAINER'); yy.addContainerBoundary(...$$[$0]); this.$=$$[$0];
break;
case 36:
console.log($$[$0-1],JSON.stringify($$[$0])); yy.addDeploymentNode('node', ...$$[$0]); this.$=$$[$0];
break;
case 37:
console.log($$[$0-1],JSON.stringify($$[$0])); yy.addDeploymentNode('nodeL', ...$$[$0]); this.$=$$[$0];
break;
case 38:
console.log($$[$0-1],JSON.stringify($$[$0])); yy.addDeploymentNode('nodeR', ...$$[$0]); this.$=$$[$0];
break;
case 39:
 yy.popBoundaryParseStack() 
break;
case 43:
console.log($$[$0-1],JSON.stringify($$[$0])); yy.addPersonOrSystem('person', ...$$[$0]); this.$=$$[$0];
break;
case 44:
console.log($$[$0-1],JSON.stringify($$[$0])); yy.addPersonOrSystem('external_person', ...$$[$0]); this.$=$$[$0];
break;
case 45:
console.log($$[$0-1],JSON.stringify($$[$0])); yy.addPersonOrSystem('system', ...$$[$0]); this.$=$$[$0];
break;
case 46:
console.log($$[$0-1],JSON.stringify($$[$0])); yy.addPersonOrSystem('system_db', ...$$[$0]); this.$=$$[$0];
break;
case 47:
console.log($$[$0-1],JSON.stringify($$[$0])); yy.addPersonOrSystem('system_queue', ...$$[$0]); this.$=$$[$0];
break;
case 48:
console.log($$[$0-1],JSON.stringify($$[$0])); yy.addPersonOrSystem('external_system', ...$$[$0]); this.$=$$[$0];
break;
case 49:
console.log($$[$0-1],JSON.stringify($$[$0])); yy.addPersonOrSystem('external_system_db', ...$$[$0]); this.$=$$[$0];
break;
case 50:
console.log($$[$0-1],JSON.stringify($$[$0])); yy.addPersonOrSystem('external_system_queue', ...$$[$0]); this.$=$$[$0];
break;
case 51:
console.log($$[$0-1],JSON.stringify($$[$0])); yy.addContainer('container', ...$$[$0]); this.$=$$[$0];
break;
case 52:
console.log($$[$0-1],JSON.stringify($$[$0])); yy.addContainer('container_db', ...$$[$0]); this.$=$$[$0];
break;
case 53:
console.log($$[$0-1],JSON.stringify($$[$0])); yy.addContainer('container_queue', ...$$[$0]); this.$=$$[$0];
break;
case 54:
console.log($$[$0-1],JSON.stringify($$[$0])); yy.addContainer('external_container', ...$$[$0]); this.$=$$[$0];
break;
case 55:
console.log($$[$0-1],JSON.stringify($$[$0])); yy.addContainer('external_container_db', ...$$[$0]); this.$=$$[$0];
break;
case 56:
console.log($$[$0-1],JSON.stringify($$[$0])); yy.addContainer('external_container_queue', ...$$[$0]); this.$=$$[$0];
break;
case 57:
console.log($$[$0-1],JSON.stringify($$[$0])); yy.addComponent('component', ...$$[$0]); this.$=$$[$0];
break;
case 58:
console.log($$[$0-1],JSON.stringify($$[$0])); yy.addComponent('component_db', ...$$[$0]); this.$=$$[$0];
break;
case 59:
console.log($$[$0-1],JSON.stringify($$[$0])); yy.addComponent('component_queue', ...$$[$0]); this.$=$$[$0];
break;
case 60:
console.log($$[$0-1],JSON.stringify($$[$0])); yy.addComponent('external_component', ...$$[$0]); this.$=$$[$0];
break;
case 61:
console.log($$[$0-1],JSON.stringify($$[$0])); yy.addComponent('external_component_db', ...$$[$0]); this.$=$$[$0];
break;
case 62:
console.log($$[$0-1],JSON.stringify($$[$0])); yy.addComponent('external_component_queue', ...$$[$0]); this.$=$$[$0];
break;
case 64:
console.log($$[$0-1],JSON.stringify($$[$0])); yy.addRel('rel', ...$$[$0]); this.$=$$[$0];
break;
case 65:
console.log($$[$0-1],JSON.stringify($$[$0])); yy.addRel('birel', ...$$[$0]); this.$=$$[$0];
break;
case 66:
console.log($$[$0-1],JSON.stringify($$[$0])); yy.addRel('rel_u', ...$$[$0]); this.$=$$[$0];
break;
case 67:
console.log($$[$0-1],JSON.stringify($$[$0])); yy.addRel('rel_d', ...$$[$0]); this.$=$$[$0];
break;
case 68:
console.log($$[$0-1],JSON.stringify($$[$0])); yy.addRel('rel_l', ...$$[$0]); this.$=$$[$0];
break;
case 69:
console.log($$[$0-1],JSON.stringify($$[$0])); yy.addRel('rel_r', ...$$[$0]); this.$=$$[$0];
break;
case 70:
console.log($$[$0-1],JSON.stringify($$[$0])); yy.addRel('rel_b', ...$$[$0]); this.$=$$[$0];
break;
case 71:
console.log($$[$0-1],JSON.stringify($$[$0])); $$[$0].splice(0, 1); yy.addRel('rel', ...$$[$0]); this.$=$$[$0];
break;
case 72:
 console.log('PUSH ATTRIBUTE: ', $$[$0]); this.$ = [$$[$0]]; 
break;
case 73:
 console.log('PUSH ATTRIBUTE: ', $$[$0-1]); $$[$0].unshift($$[$0-1]); this.$=$$[$0];
break;
case 74: case 75:
  this.$ = $$[$0].trim(); 
break;
case 76:
  this.$ = ""; 
break;
}
},
table: [{3:1,4:2,5:3,6:4,7:$V0,8:$V1,9:$V2,10:$V3,11:5,12:10,18:$V4,22:$V5,25:$V6,26:$V7,27:$V8,28:$V9},{1:[3]},{1:[2,1]},{1:[2,2]},{3:17,4:2,5:3,6:4,7:$V0,8:$V1,9:$V2,10:$V3,11:5,12:10,18:$V4,22:$V5,25:$V6,26:$V7,27:$V8,28:$V9},{1:[2,8]},{1:[2,4]},{1:[2,5]},{1:[2,6]},{1:[2,7]},{13:18,19:[1,19]},{15:[1,20]},{15:[1,21]},{15:[1,22]},{15:[1,23]},{15:[1,24]},{19:[2,11]},{1:[2,3]},{14:25,16:[1,26],21:$Va},o([16,21],[2,12]),{23:28,29:29,30:30,31:31,32:$Vb,33:$Vc,34:55,35:64,37:65,39:$Vd,41:$Ve,42:$Vf,43:$Vg,44:$Vh,45:$Vi,46:$Vj,48:32,49:$Vk,50:$Vl,51:$Vm,52:$Vn,53:$Vo,54:$Vp,55:$Vq,56:$Vr,57:$Vs,58:$Vt,59:$Vu,60:$Vv,61:$Vw,62:$Vx,63:$Vy,64:$Vz,65:$VA,66:$VB,67:$VC,68:$VD,69:$VE,70:$VF,71:$VG,72:$VH,73:$VI,74:$VJ,75:$VK,76:$VL},{23:73,29:29,30:30,31:31,32:$Vb,33:$Vc,34:55,35:64,37:65,39:$Vd,41:$Ve,42:$Vf,43:$Vg,44:$Vh,45:$Vi,46:$Vj,48:32,49:$Vk,50:$Vl,51:$Vm,52:$Vn,53:$Vo,54:$Vp,55:$Vq,56:$Vr,57:$Vs,58:$Vt,59:$Vu,60:$Vv,61:$Vw,62:$Vx,63:$Vy,64:$Vz,65:$VA,66:$VB,67:$VC,68:$VD,69:$VE,70:$VF,71:$VG,72:$VH,73:$VI,74:$VJ,75:$VK,76:$VL},{23:74,29:29,30:30,31:31,32:$Vb,33:$Vc,34:55,35:64,37:65,39:$Vd,41:$Ve,42:$Vf,43:$Vg,44:$Vh,45:$Vi,46:$Vj,48:32,49:$Vk,50:$Vl,51:$Vm,52:$Vn,53:$Vo,54:$Vp,55:$Vq,56:$Vr,57:$Vs,58:$Vt,59:$Vu,60:$Vv,61:$Vw,62:$Vx,63:$Vy,64:$Vz,65:$VA,66:$VB,67:$VC,68:$VD,69:$VE,70:$VF,71:$VG,72:$VH,73:$VI,74:$VJ,75:$VK,76:$VL},{23:75,29:29,30:30,31:31,32:$Vb,33:$Vc,34:55,35:64,37:65,39:$Vd,41:$Ve,42:$Vf,43:$Vg,44:$Vh,45:$Vi,46:$Vj,48:32,49:$Vk,50:$Vl,51:$Vm,52:$Vn,53:$Vo,54:$Vp,55:$Vq,56:$Vr,57:$Vs,58:$Vt,59:$Vu,60:$Vv,61:$Vw,62:$Vx,63:$Vy,64:$Vz,65:$VA,66:$VB,67:$VC,68:$VD,69:$VE,70:$VF,71:$VG,72:$VH,73:$VI,74:$VJ,75:$VK,76:$VL},{23:76,29:29,30:30,31:31,32:$Vb,33:$Vc,34:55,35:64,37:65,39:$Vd,41:$Ve,42:$Vf,43:$Vg,44:$Vh,45:$Vi,46:$Vj,48:32,49:$Vk,50:$Vl,51:$Vm,52:$Vn,53:$Vo,54:$Vp,55:$Vq,56:$Vr,57:$Vs,58:$Vt,59:$Vu,60:$Vv,61:$Vw,62:$Vx,63:$Vy,64:$Vz,65:$VA,66:$VB,67:$VC,68:$VD,69:$VE,70:$VF,71:$VG,72:$VH,73:$VI,74:$VJ,75:$VK,76:$VL},{15:[1,77]},{17:78,20:[1,79]},{15:[2,14]},{24:[1,80]},o($VM,[2,20],{48:32,34:55,35:64,37:65,30:81,39:$Vd,41:$Ve,42:$Vf,43:$Vg,44:$Vh,45:$Vi,46:$Vj,49:$Vk,50:$Vl,51:$Vm,52:$Vn,53:$Vo,54:$Vp,55:$Vq,56:$Vr,57:$Vs,58:$Vt,59:$Vu,60:$Vv,61:$Vw,62:$Vx,63:$Vy,64:$Vz,65:$VA,66:$VB,67:$VC,68:$VD,69:$VE,70:$VF,71:$VG,72:$VH,73:$VI,74:$VJ,75:$VK,76:$VL}),o($VM,[2,21]),o($VN,[2,23],{15:[1,82]}),o($VM,[2,40],{15:[1,83]}),o($VO,[2,26]),o($VO,[2,27]),{40:84,77:85,78:$VP,79:$VQ,80:$VR},{40:89,77:85,78:$VP,79:$VQ,80:$VR},{40:90,77:85,78:$VP,79:$VQ,80:$VR},{40:91,77:85,78:$VP,79:$VQ,80:$VR},{40:92,77:85,78:$VP,79:$VQ,80:$VR},{40:93,77:85,78:$VP,79:$VQ,80:$VR},{40:94,77:85,78:$VP,79:$VQ,80:$VR},{40:95,77:85,78:$VP,79:$VQ,80:$VR},{40:96,77:85,78:$VP,79:$VQ,80:$VR},{40:97,77:85,78:$VP,79:$VQ,80:$VR},{40:98,77:85,78:$VP,79:$VQ,80:$VR},{40:99,77:85,78:$VP,79:$VQ,80:$VR},{40:100,77:85,78:$VP,79:$VQ,80:$VR},{40:101,77:85,78:$VP,79:$VQ,80:$VR},{40:102,77:85,78:$VP,79:$VQ,80:$VR},{40:103,77:85,78:$VP,79:$VQ,80:$VR},{40:104,77:85,78:$VP,79:$VQ,80:$VR},{40:105,77:85,78:$VP,79:$VQ,80:$VR},{40:106,77:85,78:$VP,79:$VQ,80:$VR},{40:107,77:85,78:$VP,79:$VQ,80:$VR},o($VS,[2,63]),{40:108,77:85,78:$VP,79:$VQ,80:$VR},{40:109,77:85,78:$VP,79:$VQ,80:$VR},{40:110,77:85,78:$VP,79:$VQ,80:$VR},{40:111,77:85,78:$VP,79:$VQ,80:$VR},{40:112,77:85,78:$VP,79:$VQ,80:$VR},{40:113,77:85,78:$VP,79:$VQ,80:$VR},{40:114,77:85,78:$VP,79:$VQ,80:$VR},{40:115,77:85,78:$VP,79:$VQ,80:$VR},{30:116,34:55,35:64,37:65,39:$Vd,41:$Ve,42:$Vf,43:$Vg,44:$Vh,45:$Vi,46:$Vj,48:32,49:$Vk,50:$Vl,51:$Vm,52:$Vn,53:$Vo,54:$Vp,55:$Vq,56:$Vr,57:$Vs,58:$Vt,59:$Vu,60:$Vv,61:$Vw,62:$Vx,63:$Vy,64:$Vz,65:$VA,66:$VB,67:$VC,68:$VD,69:$VE,70:$VF,71:$VG,72:$VH,73:$VI,74:$VJ,75:$VK,76:$VL},{15:[1,118],38:[1,117]},{40:119,77:85,78:$VP,79:$VQ,80:$VR},{40:120,77:85,78:$VP,79:$VQ,80:$VR},{40:121,77:85,78:$VP,79:$VQ,80:$VR},{40:122,77:85,78:$VP,79:$VQ,80:$VR},{40:123,77:85,78:$VP,79:$VQ,80:$VR},{40:124,77:85,78:$VP,79:$VQ,80:$VR},{40:125,77:85,78:$VP,79:$VQ,80:$VR},{24:[1,126]},{24:[1,127]},{24:[1,128]},{24:[1,129]},o($VT,[2,9]),{14:130,21:$Va},{21:[2,13]},{1:[2,15]},o($VM,[2,22]),o($VN,[2,24],{31:31,29:131,32:$Vb,33:$Vc}),o($VM,[2,41],{29:29,30:30,31:31,48:32,34:55,35:64,37:65,23:132,32:$Vb,33:$Vc,39:$Vd,41:$Ve,42:$Vf,43:$Vg,44:$Vh,45:$Vi,46:$Vj,49:$Vk,50:$Vl,51:$Vm,52:$Vn,53:$Vo,54:$Vp,55:$Vq,56:$Vr,57:$Vs,58:$Vt,59:$Vu,60:$Vv,61:$Vw,62:$Vx,63:$Vy,64:$Vz,65:$VA,66:$VB,67:$VC,68:$VD,69:$VE,70:$VF,71:$VG,72:$VH,73:$VI,74:$VJ,75:$VK,76:$VL}),o($VS,[2,43]),o($VU,[2,72],{77:85,40:133,78:$VP,79:$VQ,80:$VR}),o($VV,[2,74]),o($VV,[2,75]),o($VV,[2,76]),o($VS,[2,44]),o($VS,[2,45]),o($VS,[2,46]),o($VS,[2,47]),o($VS,[2,48]),o($VS,[2,49]),o($VS,[2,50]),o($VS,[2,51]),o($VS,[2,52]),o($VS,[2,53]),o($VS,[2,54]),o($VS,[2,55]),o($VS,[2,56]),o($VS,[2,57]),o($VS,[2,58]),o($VS,[2,59]),o($VS,[2,60]),o($VS,[2,61]),o($VS,[2,62]),o($VS,[2,64]),o($VS,[2,65]),o($VS,[2,66]),o($VS,[2,67]),o($VS,[2,68]),o($VS,[2,69]),o($VS,[2,70]),o($VS,[2,71]),{36:134,47:[1,135]},{15:[1,136]},{38:[1,137]},o($VW,[2,32]),o($VW,[2,33]),o($VW,[2,34]),o($VW,[2,35]),o($VW,[2,36]),o($VW,[2,37]),o($VW,[2,38]),{1:[2,16]},{1:[2,17]},{1:[2,18]},{1:[2,19]},{15:[1,138]},o($VN,[2,25]),o($VM,[2,42]),o($VU,[2,73]),o($VS,[2,28]),o($VS,[2,39]),o($VX,[2,29]),o($VX,[2,30],{15:[1,139]}),o($VT,[2,10]),o($VX,[2,31])],
defaultActions: {2:[2,1],3:[2,2],5:[2,8],6:[2,4],7:[2,5],8:[2,6],9:[2,7],16:[2,11],17:[2,3],27:[2,14],79:[2,13],80:[2,15],126:[2,16],127:[2,17],128:[2,18],129:[2,19]},
parseError: function parseError (str, hash) {
    if (hash.recoverable) {
        this.trace(str);
    } else {
        var error = new Error(str);
        error.hash = hash;
        throw error;
    }
},
parse: function parse(input) {
    var self = this, stack = [0], tstack = [], vstack = [null], lstack = [], table = this.table, yytext = '', yylineno = 0, yyleng = 0, recovering = 0, TERROR = 2, EOF = 1;
    var args = lstack.slice.call(arguments, 1);
    var lexer = Object.create(this.lexer);
    var sharedState = { yy: {} };
    for (var k in this.yy) {
        if (Object.prototype.hasOwnProperty.call(this.yy, k)) {
            sharedState.yy[k] = this.yy[k];
        }
    }
    lexer.setInput(input, sharedState.yy);
    sharedState.yy.lexer = lexer;
    sharedState.yy.parser = this;
    if (typeof lexer.yylloc == 'undefined') {
        lexer.yylloc = {};
    }
    var yyloc = lexer.yylloc;
    lstack.push(yyloc);
    var ranges = lexer.options && lexer.options.ranges;
    if (typeof sharedState.yy.parseError === 'function') {
        this.parseError = sharedState.yy.parseError;
    } else {
        this.parseError = Object.getPrototypeOf(this).parseError;
    }
    function popStack(n) {
        stack.length = stack.length - 2 * n;
        vstack.length = vstack.length - n;
        lstack.length = lstack.length - n;
    }
            function lex() {
            var token;
            token = tstack.pop() || lexer.lex() || EOF;
            if (typeof token !== 'number') {
                if (token instanceof Array) {
                    tstack = token;
                    token = tstack.pop();
                }
                token = self.symbols_[token] || token;
            }
            return token;
        }
    var symbol, preErrorSymbol, state, action, a, r, yyval = {}, p, len, newState, expected;
    while (true) {
        state = stack[stack.length - 1];
        if (this.defaultActions[state]) {
            action = this.defaultActions[state];
        } else {
            if (symbol === null || typeof symbol == 'undefined') {
                symbol = lex();
            }
            action = table[state] && table[state][symbol];
        }
        if (typeof action === 'undefined' || !action.length || !action[0]) {
            var errStr = '';
            expected = [];
            for (p in table[state]) {
                if (this.terminals_[p] && p > TERROR) {
                    expected.push('\'' + this.terminals_[p] + '\'');
                }
            }
            if (lexer.showPosition) {
                errStr = 'Parse error on line ' + (yylineno + 1) + ':\n' + lexer.showPosition() + '\nExpecting ' + expected.join(', ') + ', got \'' + (this.terminals_[symbol] || symbol) + '\'';
            } else {
                errStr = 'Parse error on line ' + (yylineno + 1) + ': Unexpected ' + (symbol == EOF ? 'end of input' : '\'' + (this.terminals_[symbol] || symbol) + '\'');
            }
            this.parseError(errStr, {
                text: lexer.match,
                token: this.terminals_[symbol] || symbol,
                line: lexer.yylineno,
                loc: yyloc,
                expected: expected
            });
        }
        if (action[0] instanceof Array && action.length > 1) {
            throw new Error('Parse Error: multiple actions possible at state: ' + state + ', token: ' + symbol);
        }
        switch (action[0]) {
        case 1:
            stack.push(symbol);
            vstack.push(lexer.yytext);
            lstack.push(lexer.yylloc);
            stack.push(action[1]);
            symbol = null;
            if (!preErrorSymbol) {
                yyleng = lexer.yyleng;
                yytext = lexer.yytext;
                yylineno = lexer.yylineno;
                yyloc = lexer.yylloc;
                if (recovering > 0) {
                    recovering--;
                }
            } else {
                symbol = preErrorSymbol;
                preErrorSymbol = null;
            }
            break;
        case 2:
            len = this.productions_[action[1]][1];
            yyval.$ = vstack[vstack.length - len];
            yyval._$ = {
                first_line: lstack[lstack.length - (len || 1)].first_line,
                last_line: lstack[lstack.length - 1].last_line,
                first_column: lstack[lstack.length - (len || 1)].first_column,
                last_column: lstack[lstack.length - 1].last_column
            };
            if (ranges) {
                yyval._$.range = [
                    lstack[lstack.length - (len || 1)].range[0],
                    lstack[lstack.length - 1].range[1]
                ];
            }
            r = this.performAction.apply(yyval, [
                yytext,
                yyleng,
                yylineno,
                sharedState.yy,
                action[1],
                vstack,
                lstack
            ].concat(args));
            if (typeof r !== 'undefined') {
                return r;
            }
            if (len) {
                stack = stack.slice(0, -1 * len * 2);
                vstack = vstack.slice(0, -1 * len);
                lstack = lstack.slice(0, -1 * len);
            }
            stack.push(this.productions_[action[1]][0]);
            vstack.push(yyval.$);
            lstack.push(yyval._$);
            newState = table[stack[stack.length - 2]][stack[stack.length - 1]];
            stack.push(newState);
            break;
        case 3:
            return true;
        }
    }
    return true;
}};
/* generated by jison-lex 0.3.4 */
var lexer = (function(){
var lexer = ({

EOF:1,

parseError:function parseError(str, hash) {
        if (this.yy.parser) {
            this.yy.parser.parseError(str, hash);
        } else {
            throw new Error(str);
        }
    },

// resets the lexer, sets new input
setInput:function (input, yy) {
        this.yy = yy || this.yy || {};
        this._input = input;
        this._more = this._backtrack = this.done = false;
        this.yylineno = this.yyleng = 0;
        this.yytext = this.matched = this.match = '';
        this.conditionStack = ['INITIAL'];
        this.yylloc = {
            first_line: 1,
            first_column: 0,
            last_line: 1,
            last_column: 0
        };
        if (this.options.ranges) {
            this.yylloc.range = [0,0];
        }
        this.offset = 0;
        return this;
    },

// consumes and returns one char from the input
input:function () {
        var ch = this._input[0];
        this.yytext += ch;
        this.yyleng++;
        this.offset++;
        this.match += ch;
        this.matched += ch;
        var lines = ch.match(/(?:\r\n?|\n).*/g);
        if (lines) {
            this.yylineno++;
            this.yylloc.last_line++;
        } else {
            this.yylloc.last_column++;
        }
        if (this.options.ranges) {
            this.yylloc.range[1]++;
        }

        this._input = this._input.slice(1);
        return ch;
    },

// unshifts one char (or a string) into the input
unput:function (ch) {
        var len = ch.length;
        var lines = ch.split(/(?:\r\n?|\n)/g);

        this._input = ch + this._input;
        this.yytext = this.yytext.substr(0, this.yytext.length - len);
        //this.yyleng -= len;
        this.offset -= len;
        var oldLines = this.match.split(/(?:\r\n?|\n)/g);
        this.match = this.match.substr(0, this.match.length - 1);
        this.matched = this.matched.substr(0, this.matched.length - 1);

        if (lines.length - 1) {
            this.yylineno -= lines.length - 1;
        }
        var r = this.yylloc.range;

        this.yylloc = {
            first_line: this.yylloc.first_line,
            last_line: this.yylineno + 1,
            first_column: this.yylloc.first_column,
            last_column: lines ?
                (lines.length === oldLines.length ? this.yylloc.first_column : 0)
                 + oldLines[oldLines.length - lines.length].length - lines[0].length :
              this.yylloc.first_column - len
        };

        if (this.options.ranges) {
            this.yylloc.range = [r[0], r[0] + this.yyleng - len];
        }
        this.yyleng = this.yytext.length;
        return this;
    },

// When called from action, caches matched text and appends it on next action
more:function () {
        this._more = true;
        return this;
    },

// When called from action, signals the lexer that this rule fails to match the input, so the next matching rule (regex) should be tested instead.
reject:function () {
        if (this.options.backtrack_lexer) {
            this._backtrack = true;
        } else {
            return this.parseError('Lexical error on line ' + (this.yylineno + 1) + '. You can only invoke reject() in the lexer when the lexer is of the backtracking persuasion (options.backtrack_lexer = true).\n' + this.showPosition(), {
                text: "",
                token: null,
                line: this.yylineno
            });

        }
        return this;
    },

// retain first n characters of the match
less:function (n) {
        this.unput(this.match.slice(n));
    },

// displays already matched input, i.e. for error messages
pastInput:function () {
        var past = this.matched.substr(0, this.matched.length - this.match.length);
        return (past.length > 20 ? '...':'') + past.substr(-20).replace(/\n/g, "");
    },

// displays upcoming input, i.e. for error messages
upcomingInput:function () {
        var next = this.match;
        if (next.length < 20) {
            next += this._input.substr(0, 20-next.length);
        }
        return (next.substr(0,20) + (next.length > 20 ? '...' : '')).replace(/\n/g, "");
    },

// displays the character position where the lexing error occurred, i.e. for error messages
showPosition:function () {
        var pre = this.pastInput();
        var c = new Array(pre.length + 1).join("-");
        return pre + this.upcomingInput() + "\n" + c + "^";
    },

// test the lexed token: return FALSE when not a match, otherwise return token
test_match:function(match, indexed_rule) {
        var token,
            lines,
            backup;

        if (this.options.backtrack_lexer) {
            // save context
            backup = {
                yylineno: this.yylineno,
                yylloc: {
                    first_line: this.yylloc.first_line,
                    last_line: this.last_line,
                    first_column: this.yylloc.first_column,
                    last_column: this.yylloc.last_column
                },
                yytext: this.yytext,
                match: this.match,
                matches: this.matches,
                matched: this.matched,
                yyleng: this.yyleng,
                offset: this.offset,
                _more: this._more,
                _input: this._input,
                yy: this.yy,
                conditionStack: this.conditionStack.slice(0),
                done: this.done
            };
            if (this.options.ranges) {
                backup.yylloc.range = this.yylloc.range.slice(0);
            }
        }

        lines = match[0].match(/(?:\r\n?|\n).*/g);
        if (lines) {
            this.yylineno += lines.length;
        }
        this.yylloc = {
            first_line: this.yylloc.last_line,
            last_line: this.yylineno + 1,
            first_column: this.yylloc.last_column,
            last_column: lines ?
                         lines[lines.length - 1].length - lines[lines.length - 1].match(/\r?\n?/)[0].length :
                         this.yylloc.last_column + match[0].length
        };
        this.yytext += match[0];
        this.match += match[0];
        this.matches = match;
        this.yyleng = this.yytext.length;
        if (this.options.ranges) {
            this.yylloc.range = [this.offset, this.offset += this.yyleng];
        }
        this._more = false;
        this._backtrack = false;
        this._input = this._input.slice(match[0].length);
        this.matched += match[0];
        token = this.performAction.call(this, this.yy, this, indexed_rule, this.conditionStack[this.conditionStack.length - 1]);
        if (this.done && this._input) {
            this.done = false;
        }
        if (token) {
            return token;
        } else if (this._backtrack) {
            // recover context
            for (var k in backup) {
                this[k] = backup[k];
            }
            return false; // rule action called reject() implying the next rule should be tested instead.
        }
        return false;
    },

// return next match in input
next:function () {
        if (this.done) {
            return this.EOF;
        }
        if (!this._input) {
            this.done = true;
        }

        var token,
            match,
            tempMatch,
            index;
        if (!this._more) {
            this.yytext = '';
            this.match = '';
        }
        var rules = this._currentRules();
        for (var i = 0; i < rules.length; i++) {
            tempMatch = this._input.match(this.rules[rules[i]]);
            if (tempMatch && (!match || tempMatch[0].length > match[0].length)) {
                match = tempMatch;
                index = i;
                if (this.options.backtrack_lexer) {
                    token = this.test_match(tempMatch, rules[i]);
                    if (token !== false) {
                        return token;
                    } else if (this._backtrack) {
                        match = false;
                        continue; // rule action called reject() implying a rule MISmatch.
                    } else {
                        // else: this is a lexer rule which consumes input without producing a token (e.g. whitespace)
                        return false;
                    }
                } else if (!this.options.flex) {
                    break;
                }
            }
        }
        if (match) {
            token = this.test_match(match, rules[index]);
            if (token !== false) {
                return token;
            }
            // else: this is a lexer rule which consumes input without producing a token (e.g. whitespace)
            return false;
        }
        if (this._input === "") {
            return this.EOF;
        } else {
            return this.parseError('Lexical error on line ' + (this.yylineno + 1) + '. Unrecognized text.\n' + this.showPosition(), {
                text: "",
                token: null,
                line: this.yylineno
            });
        }
    },

// return next match that has a token
lex:function lex () {
        var r = this.next();
        if (r) {
            return r;
        } else {
            return this.lex();
        }
    },

// activates a new lexer condition state (pushes the new lexer condition state onto the condition stack)
begin:function begin (condition) {
        this.conditionStack.push(condition);
    },

// pop the previously active lexer condition state off the condition stack
popState:function popState () {
        var n = this.conditionStack.length - 1;
        if (n > 0) {
            return this.conditionStack.pop();
        } else {
            return this.conditionStack[0];
        }
    },

// produce the lexer rule set which is active for the currently active lexer condition state
_currentRules:function _currentRules () {
        if (this.conditionStack.length && this.conditionStack[this.conditionStack.length - 1]) {
            return this.conditions[this.conditionStack[this.conditionStack.length - 1]].rules;
        } else {
            return this.conditions["INITIAL"].rules;
        }
    },

// return the currently active lexer condition state; when an index argument is provided it produces the N-th previous condition state, if available
topState:function topState (n) {
        n = this.conditionStack.length - 1 - Math.abs(n || 0);
        if (n >= 0) {
            return this.conditionStack[n];
        } else {
            return "INITIAL";
        }
    },

// alias for begin(condition)
pushState:function pushState (condition) {
        this.begin(condition);
    },

// return the number of states currently on the stack
stateStackSize:function stateStackSize() {
        return this.conditionStack.length;
    },
options: {},
performAction: function anonymous(yy,yy_,$avoiding_name_collisions,YY_START) {
var YYSTATE=YY_START;
switch($avoiding_name_collisions) {
case 0: this.begin('open_directive'); return 18; 
break;
case 1:return 7;
break;
case 2:return 8;
break;
case 3:return 9;
break;
case 4:return 10;
break;
case 5: this.begin('type_directive'); return 19; 
break;
case 6: this.popState(); this.begin('arg_directive'); return 16; 
break;
case 7: this.popState(); this.popState(); return 21; 
break;
case 8:return 20;
break;
case 9:/* skip comments */
break;
case 10:c            /* skip comments */
break;
case 11:return 32;
break;
case 12:return 33;
break;
case 13:return 15;
break;
case 14:/* skip whitespace */
break;
case 15:return 22;
break;
case 16:return 25;
break;
case 17:return 26;
break;
case 18:return 27;
break;
case 19:return 28;
break;
case 20: this.begin("person_ext"); console.log('begin person_ext'); return 50;
break;
case 21: this.begin("person"); console.log('begin person'); return 49;
break;
case 22: this.begin("system_ext_queue"); console.log('begin system_ext_queue'); return 56;
break;
case 23: this.begin("system_ext_db"); console.log('begin system_ext_db'); return 55;
break;
case 24: this.begin("system_ext"); console.log('begin system_ext'); return 54;
break;
case 25: this.begin("system_queue"); console.log('begin system_queue'); return 53;
break;
case 26: this.begin("system_db"); console.log('begin system_db'); return 52;
break;
case 27: this.begin("system"); console.log('begin system'); return 51;
break;
case 28: this.begin("boundary"); console.log('begin boundary'); return 42;
break;
case 29: this.begin("enterprise_boundary"); console.log('begin enterprise_boundary'); return 39;
break;
case 30: this.begin("system_boundary"); console.log('begin system_boundary'); return 41;
break;
case 31: this.begin("container_ext_queue"); console.log('begin container_ext_queue'); return 62;
break;
case 32: this.begin("container_ext_db"); console.log('begin container_ext_db'); return 61;
break;
case 33: this.begin("container_ext"); console.log('begin container_ext'); return 60;
break;
case 34: this.begin("container_queue"); console.log('begin container_queue'); return 59;
break;
case 35: this.begin("container_db"); console.log('begin container_db'); return 58;
break;
case 36: this.begin("container"); console.log('begin container'); return 57;
break;
case 37: this.begin("container_boundary"); console.log('begin container_boundary'); return 43;
break;
case 38: this.begin("component_ext_queue"); console.log('begin component_ext_queue'); return 68;
break;
case 39: this.begin("component_ext_db"); console.log('begin component_ext_db'); return 67;
break;
case 40: this.begin("component_ext"); console.log('begin component_ext'); return 66;
break;
case 41: this.begin("component_queue"); console.log('begin component_queue'); return 65;
break;
case 42: this.begin("component_db"); console.log('begin component_db'); return 64;
break;
case 43: this.begin("component"); console.log('begin component'); return 63;
break;
case 44: this.begin("node"); console.log('begin node'); return 44;
break;
case 45: this.begin("node"); console.log('begin node'); return 44;
break;
case 46: this.begin("node_l"); console.log('begin node_l'); return 45;
break;
case 47: this.begin("node_r"); console.log('begin node_r'); return 46;
break;
case 48: this.begin("rel"); console.log('begin rel'); return 69;
break;
case 49: this.begin("birel"); console.log('begin birel'); return 70;
break;
case 50: this.begin("rel_u"); console.log('begin rel_u'); return 71;
break;
case 51: this.begin("rel_u"); console.log('begin rel_u'); return 71;
break;
case 52: this.begin("rel_d"); console.log('begin rel_d'); return 72;
break;
case 53: this.begin("rel_d"); console.log('begin rel_d'); return 72;
break;
case 54: this.begin("rel_l"); console.log('begin rel_l'); return 73;
break;
case 55: this.begin("rel_l"); console.log('begin rel_l'); return 73;
break;
case 56: this.begin("rel_r"); console.log('begin rel_r'); return 74;
break;
case 57: this.begin("rel_r"); console.log('begin rel_r'); return 74;
break;
case 58: this.begin("rel_b"); console.log('begin rel_b'); return 75;
break;
case 59: this.begin("rel_index"); console.log('begin rel_index'); return 76;
break;
case 60:return "EOF_IN_STRUCT";
break;
case 61: console.log('begin attribute with ATTRIBUTE_EMPTY'); this.begin("attribute"); return "ATTRIBUTE_EMPTY";
break;
case 62: console.log('begin attribute'); this.begin("attribute"); 
break;
case 63: console.log('STOP attribute'); this.popState();console.log('STOP diagram'); this.popState();
break;
case 64: console.log(',,'); return 80;
break;
case 65: console.log(','); 
break;
case 66: console.log('ATTRIBUTE_EMPTY'); return 80;
break;
case 67: console.log('begin string'); this.begin("string");
break;
case 68: console.log('STOP string');  this.popState(); 
break;
case 69: console.log('STR'); return "STR";
break;
case 70: console.log('not STR'); return "STR";
break;
case 71: /* this.begin("lbrace"); */ console.log('begin boundary block'); return "LBRACE";
break;
case 72: /* this.popState(); */ console.log('STOP boundary block'); return "RBRACE";
break;
case 73:return 'SPACE';
break;
case 74:return 'EOL';
break;
case 75:return 24;
break;
}
},
rules: [/^(?:%%\{)/,/^(?:.*direction\s+TB[^\n]*)/,/^(?:.*direction\s+BT[^\n]*)/,/^(?:.*direction\s+RL[^\n]*)/,/^(?:.*direction\s+LR[^\n]*)/,/^(?:((?:(?!\}%%)[^:.])*))/,/^(?::)/,/^(?:\}%%)/,/^(?:((?:(?!\}%%).|\n)*))/,/^(?:%%(?!\{)*[^\n]*(\r?\n?)+)/,/^(?:%%[^\n]*(\r?\n)*)/,/^(?:title\s[^#\n;]+)/,/^(?:accDescription\s[^#\n;]+)/,/^(?:\s*(\r?\n)+)/,/^(?:\s+)/,/^(?:C4Context\b)/,/^(?:C4Container\b)/,/^(?:C4Component\b)/,/^(?:C4Dynamic\b)/,/^(?:C4Deployment\b)/,/^(?:Person_Ext\b)/,/^(?:Person\b)/,/^(?:SystemQueue_Ext\b)/,/^(?:SystemDb_Ext\b)/,/^(?:System_Ext\b)/,/^(?:SystemQueue\b)/,/^(?:SystemDb\b)/,/^(?:System\b)/,/^(?:Boundary\b)/,/^(?:Enterprise_Boundary\b)/,/^(?:System_Boundary\b)/,/^(?:ContainerQueue_Ext\b)/,/^(?:ContainerDb_Ext\b)/,/^(?:Container_Ext\b)/,/^(?:ContainerQueue\b)/,/^(?:ContainerDb\b)/,/^(?:Container\b)/,/^(?:Container_Boundary\b)/,/^(?:ComponentQueue_Ext\b)/,/^(?:ComponentDb_Ext\b)/,/^(?:Component_Ext\b)/,/^(?:ComponentQueue\b)/,/^(?:ComponentDb\b)/,/^(?:Component\b)/,/^(?:Deployment_Node\b)/,/^(?:Node\b)/,/^(?:Node_L\b)/,/^(?:Node_R\b)/,/^(?:Rel\b)/,/^(?:BiRel\b)/,/^(?:Rel_Up\b)/,/^(?:Rel_U\b)/,/^(?:Rel_Down\b)/,/^(?:Rel_D\b)/,/^(?:Rel_Left\b)/,/^(?:Rel_L\b)/,/^(?:Rel_Right\b)/,/^(?:Rel_R\b)/,/^(?:Rel_Back\b)/,/^(?:RelIndex\b)/,/^(?:$)/,/^(?:[(][ ]*[,])/,/^(?:[(])/,/^(?:[)])/,/^(?:,,)/,/^(?:,)/,/^(?:[ ]*["]["])/,/^(?:[ ]*["])/,/^(?:["])/,/^(?:[^"]*)/,/^(?:[^,]+)/,/^(?:\{)/,/^(?:\})/,/^(?:[\s]+)/,/^(?:[\n\r]+)/,/^(?:$)/],
conditions: {"arg_directive":{"rules":[7,8],"inclusive":false},"type_directive":{"rules":[6,7],"inclusive":false},"open_directive":{"rules":[5],"inclusive":false},"string":{"rules":[68,69],"inclusive":false},"attribute":{"rules":[63,64,65,66,67,70],"inclusive":false},"rel_b":{"rules":[60,61,62,63],"inclusive":false},"rel_r":{"rules":[60,61,62,63],"inclusive":false},"rel_l":{"rules":[60,61,62,63],"inclusive":false},"rel_d":{"rules":[60,61,62,63],"inclusive":false},"rel_u":{"rules":[60,61,62,63],"inclusive":false},"rel_bi":{"rules":[],"inclusive":false},"rel":{"rules":[60,61,62,63],"inclusive":false},"node_r":{"rules":[60,61,62,63],"inclusive":false},"node_l":{"rules":[60,61,62,63],"inclusive":false},"node":{"rules":[60,61,62,63],"inclusive":false},"index":{"rules":[],"inclusive":false},"rel_index":{"rules":[60,61,62,63],"inclusive":false},"component_ext_queue":{"rules":[],"inclusive":false},"component_ext_db":{"rules":[60,61,62,63],"inclusive":false},"component_ext":{"rules":[60,61,62,63],"inclusive":false},"component_queue":{"rules":[60,61,62,63],"inclusive":false},"component_db":{"rules":[60,61,62,63],"inclusive":false},"component":{"rules":[60,61,62,63],"inclusive":false},"container_boundary":{"rules":[60,61,62,63],"inclusive":false},"container_ext_queue":{"rules":[],"inclusive":false},"container_ext_db":{"rules":[60,61,62,63],"inclusive":false},"container_ext":{"rules":[60,61,62,63],"inclusive":false},"container_queue":{"rules":[60,61,62,63],"inclusive":false},"container_db":{"rules":[60,61,62,63],"inclusive":false},"container":{"rules":[60,61,62,63],"inclusive":false},"birel":{"rules":[60,61,62,63],"inclusive":false},"system_boundary":{"rules":[60,61,62,63],"inclusive":false},"enterprise_boundary":{"rules":[60,61,62,63],"inclusive":false},"boundary":{"rules":[60,61,62,63],"inclusive":false},"system_ext_queue":{"rules":[60,61,62,63],"inclusive":false},"system_ext_db":{"rules":[60,61,62,63],"inclusive":false},"system_ext":{"rules":[60,61,62,63],"inclusive":false},"system_queue":{"rules":[60,61,62,63],"inclusive":false},"system_db":{"rules":[60,61,62,63],"inclusive":false},"system":{"rules":[60,61,62,63],"inclusive":false},"person_ext":{"rules":[60,61,62,63],"inclusive":false},"person":{"rules":[60,61,62,63],"inclusive":false},"INITIAL":{"rules":[0,1,2,3,4,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42,43,44,45,46,47,48,49,50,51,52,53,54,55,56,57,58,59,71,72,73,74,75],"inclusive":true}}
});
return lexer;
})();
parser.lexer = lexer;
function Parser () {
  this.yy = {};
}
Parser.prototype = parser;parser.Parser = Parser;
return new Parser;
})();


if (typeof require !== 'undefined' && typeof exports !== 'undefined') {
exports.parser = parser;
exports.Parser = parser.Parser;
exports.parse = function () { return parser.parse.apply(parser, arguments); };
exports.main = function commonjsMain (args) {
    if (!args[1]) {
        console.log('Usage: '+args[0]+' FILE');
        process.exit(1);
    }
    var source = require('fs').readFileSync(require('path').normalize(args[1]), "utf8");
    return exports.parser.parse(source);
};
if (typeof module !== 'undefined' && require.main === module) {
  exports.main(process.argv.slice(1));
}
}